'use strict';

var _rollupPluginBabelHelpers = require('../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var PropTypes = require('prop-types');
var index = require('../Selectable/index.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

var Option = /*#__PURE__*/function (_React$Component) {
  _rollupPluginBabelHelpers.inherits(Option, _React$Component);

  var _super = _rollupPluginBabelHelpers.createSuper(Option);

  function Option() {
    _rollupPluginBabelHelpers.classCallCheck(this, Option);

    return _super.apply(this, arguments);
  }

  _rollupPluginBabelHelpers.createClass(Option, [{
    key: "buttonClasses",
    value: function buttonClasses() {
      return [].concat(_rollupPluginBabelHelpers.toConsumableArray(this.props.classNames), ['ds-filter-menu-dropdown-list-link']);
    }
  }, {
    key: "render",
    value: function render() {
      var selectableProps = _rollupPluginBabelHelpers.objectSpread2({}, this.props, {
        classNames: this.buttonClasses()
      });

      return /*#__PURE__*/React__default['default'].createElement(index, selectableProps);
    }
  }]);

  return Option;
}(React__default['default'].Component);

_rollupPluginBabelHelpers.defineProperty(Option, "propTypes", {
  classNames: PropTypes__default['default'].arrayOf(PropTypes__default['default'].string),
  label: PropTypes__default['default'].string.isRequired,
  onSelect: PropTypes__default['default'].func.isRequired,
  selected: PropTypes__default['default'].bool,
  value: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].number]).isRequired
});

_rollupPluginBabelHelpers.defineProperty(Option, "defaultProps", {
  classNames: [],
  selected: false
});

module.exports = Option;
